import React, { useContext } from 'react';
import { Button, Collapse, Flex, Tabs } from 'antd';

import { EMPTY_ID } from '@totem/components/common/reference/ReferenceSelector';
import EventTypeTable from '@totem/components/settings/sections/nozomi/eventConfiguration/eventTypeTable';
import NozomiEventConfigContext from '@totem/components/settings/sections/nozomi/eventConfiguration/nozomiEventConfigContext';
import RiskTable from '@totem/components/settings/sections/nozomi/eventConfiguration/riskTable';
import { NozimiEventConfigurationData } from '@totem/components/settings/sections/nozomi/eventConfiguration/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import IBDIcon from '@totem/styles/Icon';

type Props = {
  canEdit: boolean;
  eventConfiguration: NozimiEventConfigurationData;
};

const OrganizationGroup = ({ canEdit, eventConfiguration }: Props) => {
  const { userProfile } = useContext(UserProfileContext);
  const { hasChanges, onAction } = useContext(NozomiEventConfigContext);

  let organizationName = 'Global (Default Settings)';
  if (eventConfiguration.organizationId !== EMPTY_ID) {
    organizationName = userProfile.organization.name;
  }

  return (
    <Collapse
      items={[
        {
          key: 'organizationGroup',
          label: organizationName,
          extra: canEdit && hasChanges && (
            <Flex justify="flex-end" align="center">
              <div style={{ marginRight: '16px' }}>
                <span style={{ backgroundColor: '#FF6666', padding: '8px' }}>
                  <b>You have unsaved changes --&gt;</b>
                </span>
              </div>
              <Button
                shape={'circle'}
                icon={<IBDIcon name={'Save'} title={'Save'} />}
                onClick={(event) => {
                  onAction('save', '');

                  event.stopPropagation();

                  event.nativeEvent.stopImmediatePropagation();
                }}
              />
            </Flex>
          ),
          children: (
            <Tabs
              items={[
                {
                  key: 'risks',
                  label: 'Risks',
                  children: (
                    <RiskTable
                      canEdit={canEdit}
                      riskItems={eventConfiguration.riskConfiguration}
                    />
                  ),
                },
                {
                  key: 'eventTypes',
                  label: 'Exceptions by Event Type',
                  children: (
                    <EventTypeTable
                      canEdit={canEdit}
                      typeItems={eventConfiguration.typeConfiguration}
                    />
                  ),
                },
              ]}
            />
          ),
        },
      ]}
    />
  );
};

export default OrganizationGroup;
